import { InjectionToken } from '@angular/core';
import { LatLng } from 'leaflet';

export interface MapPolygon<T = any> {
	id: string;
	/** Äußere Ringe aller Sub-Polygone (MultiPolygon-Unterstützung) */
	polygons: LatLng[][];
	data: T;
	label?: string;
	style?: {
		color?: string;
		fillColor?: string;
		fillOpacity?: number;
		weight?: number;
	};
}

export interface MapPolygonHandler<T> {
	toMapPolygon(document: T): MapPolygon<T>;
	hasValidPolygon(document: T): boolean;
}

export const MAP_POLYGON_HANDLER = new InjectionToken<MapPolygonHandler<any>>(
	'MAP_POLYGON_HANDLER'
);
